import type { StateDefinitionT } from "@patient-watch/types";
import Diary from "../icons/Diary";
import ActiveMonitoring from "./ActiveMonitoring";
import AwaitingReview from "./AwaitingReview";
import BeenAWhile from "./BeenAWhile";
import ClipboardWarning from "./ClipboardWarning";
import ClockQuestion from "./ClockQuestion";
import DiaryQuestion from "./DiaryQuestion";
import DiaryTick from "./DiaryTick";
import DiaryWarning from "./DiaryWarning";
import EmailConfirmed from "./EmailConfirmed";
import Empty from "./Empty";
import FinishFlag from "./FinishFlag";
import Flag from "./Flag";
import Invited from "./Invited";
import MIA from "./MIA";

export const stateIcons = {
    ActiveMonitoring,
    AwaitingReview,
    Diary,
    DiaryTick,
    Flag,
    ClockQuestion,
    DiaryQuestion,
    EmailConfirmed,
    DiaryWarning,
    ClipboardWarning,
    Empty,
    BeenAWhile,
    FinishFlag,
    MIA,
    Invited,
};

export const states: StateDefinitionT[] = [
    {
        id: "1",
        name: "Improved",
        description: "Primary outcome score shows sustained improvement over time",
        state_key: "PAIN_REDUCED",
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
    },
    {
        id: "2",
        name: "Worsening again",
        description: "Primary outcome score improved initially but has worsened again",
        state_key: "PAIN_SPIKE",
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
    },
    {
        id: "3",
        name: "Not improving",
        description: "Primary outcome score has not improved from baseline",
        state_key: "NEVER_WORKED",
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
    },
];

export const findStateIcon = (stateKey: string) => {
    switch (stateKey) {
        case "PAIN_REDUCED":
            return <Flag color="green" />;
        case "READY_TO_REVIEW":
            return <AwaitingReview />;
        case "PAIN_SPIKE":
            return <Flag color="amber" />;
        case "NEVER_WORKED":
        case "HIGH":
        case "LOW":
            return <Flag color="red" />;
        case "ACTIVE":
        case "NORMAL":
            return <DiaryTick />;
        case "COMPLETED":
            return <FinishFlag />;
        case "LATE_TO_LOG":
            return <BeenAWhile />;
        case "LATE_TO_START":
            return <ClockQuestion />;
        case "PENDING":
            return <Invited />;
        case "NO_TRACKER":
        case "EMPTY_DIARY":
            return <EmailConfirmed />;
        case "DISCARDED":
            return <Flag color="black" />;
        default:
            return <Flag color="gray" />;
    }
};

export const findStateName = (stateKey: string) => {
    const state = states.find((s) => s.state_key === stateKey);
    return state?.name || "Unknown State";
};

export default stateIcons;
